

































import { Component, Vue, Watch } from 'vue-property-decorator';
import { authModule } from '@/store';
import LoginForm from '@/components/auth/LoginForm.vue';
import RegisterForm from '@/components/auth/RegisterForm.vue';
import { claimLoginRedirect, outstandingObligations } from '@/accountNotices';

@Component({
  components: { LoginForm, RegisterForm },
})
export default class extends Vue {
  loginTabs: number = 0;

  get authClass() {
    return this.loginTabs === 0 ? 'login' : 'register';
  }

  /**
   * "Redirects unverified users to verification page on next login."
   *
   * On a credential login only - this fires from the login form's success, not
   * from a watcher on `isLoggedIn`, so reloading the page or returning to the
   * site on an existing session does not re-trigger it. Log out and back in and
   * it fires again, which is what the scope line means by "next login".
   *
   * Only from this page. `LoginPopup` mounts the same form and deliberately
   * does not bind this - see the comment in `LoginForm.vue`.
   *
   * A user with nothing outstanding is left alone, and so is the `?next=` deep
   * link the 401 handler adds: it is carried over as `?continue=` and offered
   * as a button rather than followed, so the notice is seen but the journey is
   * not thrown away.
   */
  loginSuccess() {
    if (!outstandingObligations().any) {
      return;
    }
    const next = this.$route.query.next;
    const carry = Array.isArray(next) ? next[0] || '' : next || '';
    if (carry) {
      // Claimed synchronously, before the navigation, so App.vue's `?next=`
      // watcher is certain to see it whenever its queue flushes. Only when
      // there is a `next` to suppress: that watcher is the only consumer, so
      // claiming with no deep link would leave the flag set for a later login.
      claimLoginRedirect();
    }
    this.$router.replace({
      name: 'account-notices',
      query: carry ? { continue: carry } : {},
    });
  }

  registerSuccess() {
    // Deliberately stays on the Register tab: RegisterForm swaps itself for the
    // "check your email" state, which is the whole point of the new flow. Do
    // not switch to Login here - it would hide that message and tell the user
    // to log in as though nothing else were needed.
  }

  clearLogin() {
    (this.$refs.loginComponent as LoginForm).clear();
    (this.$refs.registerComponent as RegisterForm).clear();
  }

  @Watch('loginTabs')
  routeChanged() {
    this.clearLogin();
  }

  mounted() {
    if (authModule.isLoggedIn) {
      this.$router.push({ name: 'home' });
    }
  }
}
